import installer from './defaults'
export * from '@lit-element/components'
export * from '@lit-element/constants'
export * from '@lit-element/directives'
export * from '@lit-element/hooks'
export * from './make-installer'

export const install = installer.install
export const version = installer.version
export default installer

export { default as dayjs } from 'dayjs'
